import { inject, injectable } from "tsyringe";
import type { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { wellbeingEndpoints } from "src/domains/wellbeing/constants/endpoints";
import {
    IWellbeingRepository,
    WellbeingTokenResponse,
} from "src/domains/wellbeing/types";
import type { HttpRequestClient } from "src/infra/http/types";
import { HttpUtils } from "src/infra/http/utils";
import { Environment } from "src/libs/environment";

@injectable()
class WellbeingRepository implements IWellbeingRepository {
    static key = "WellbeingRepository";
    private readonly httpUtils: HttpUtils;
    private readonly host: string;

    constructor(@inject("FetchClient") private httpClient: HttpRequestClient) {
        this.httpUtils = new HttpUtils();
        this.host = Environment.string("APIMGMT_URL");
    }

    getToken(hasRentPolicy: boolean): Observable<WellbeingTokenResponse> {
        return this.httpClient.getJSON<WellbeingTokenResponse>(
            `${wellbeingEndpoints.authentication}?tienePolizaRenta=${hasRentPolicy}`,
            {
                host: this.host,
                isPublicRequest: false,
                customHeader: {
                    ...this.httpUtils.getBaseHeaders(),
                    ...this.httpUtils.getMsBaseHeaders(),
                },
            }
        );
    }

    getUserSegment(): Observable<{ codigoSegmentacion: number }> {
        const endpoint = wellbeingEndpoints.getSegment;
        return this.httpClient
            .getJSON<{ codigoSegmentacion: number }[]>(endpoint, {
                host: Environment.string("APIMGMT_URL"),
                isPublicRequest: false,
                customHeader: {
                    ...new HttpUtils().getBaseHeaders(),
                    ...new HttpUtils().getMsBaseHeaders(window.userIdentity),
                },
            })
            .pipe(map((response) => response.pop()!));
    }

    hasAccess(): Observable<boolean> {
        const host = Environment.string("APIMGMT_URL");
        const endpoint = wellbeingEndpoints.validateAccess;
        return this.httpClient.getJSON(endpoint, {
            host,
            isPublicRequest: false,
            customHeader: {
                ...new HttpUtils().getBaseHeaders(),
                ...new HttpUtils().getMsBaseHeaders(window.userIdentity),
            },
        });
    }
}

export { WellbeingRepository };
